import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import extend from 'lodash/extend';
import NotFound from '../../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';
import AllFeed from '../../../../components/all_feed/all_feed';
import Ad from '../../../../components/ad/ad';
import Container from '../../../../components/post/container';
import loadData from './video_page_state_manager';
import { canUseDOM } from 'exenv';

// eslint-disable-next-line react/prefer-stateless-function
class VideoPage extends Component {
  static loadData(store) {
    return loadData(store);
  }

  componentDidMount() {
    const adData = get(this.props.videoPage, 'ads');

    if (canUseDOM) {
      // Update the data layer
      if (adData !== undefined) {
        extend(window.digitalData.page.pageInfo, {
          adPath: `/4160/mv.fc/${adData.model.adzone}`
        });
      }
    }
  }

  render() {
    if (this.props.status === 404 || this.props.status === 500) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.videoPage.isLoading) {
      return (
        <section className="video-page">
          <article className="video-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const {
      videoPage,
      jwVideo,
      jwRelatedVideo,
      jwNewestVideo,
      config
    } = this.props;
    const adData = get(this.props.videoPage, 'ads');
    const tagData = get(jwVideo, 'data.playlist[0].tags', []);
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      {
        model: Object.assign(
          {
            tags: tagData.map(tag => tag.name.replace(' ', '-').toLowerCase())
          },
          get(adData, 'model')
        )
      }
    );

    const containerProps = {
      config: this.props.config,
      posts: [get(jwVideo, 'data.playlist[0]')],
      related: get(jwRelatedVideo, 'data.playlist', []),
      isFirstPost: true,
      combinedAdModel,
      isDesktop: false, // disable sticky sidebars and social
      pageNum: 1,
      mediaid: get(jwVideo, 'data.playlist[0].mediaid'),
      videoAdData: get(videoPage, 'ads.model', {}),
      tags: tagData
    };

    return (
      <section className="post-page">
        <Container {...containerProps} />

        <Ad
          {...combinedAdModel}
          noLazyLoad={true}
          pos="atf"
          name="flexiblebillboard_1"
        />
        <AllFeed
          adModel={combinedAdModel}
          titleOverride="Latest Videos"
          stories={get(jwNewestVideo, 'data.playlist', [])}
          allRendered={true}
          config={config}
        />

        <Ad {...combinedAdModel} name="flexiblebillboard_2" />
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    videoPage: get(state, 'videoPage', { error: true }),
    jwVideo: get(state, 'jwVideo'),
    jwRelatedVideo: get(state, 'jwRelatedVideo'),
    jwNewestVideo: get(state, 'jwNewestVideo')
  };
}

VideoPage.propTypes = {
  config: PropTypes.shape({}).isRequired,
  status: PropTypes.number.isRequired,
  videoPage: PropTypes.shape({
    isLoading: PropTypes.bool
  }).isRequired,
  jwVideo: PropTypes.shape({}).isRequired,
  jwRelatedVideo: PropTypes.shape({}).isRequired,
  jwNewestVideo: PropTypes.shape({}).isRequired,
  dispatchSetFloatingVideoState: PropTypes.func.isRequired
};

export default connect(mapStateToProps)(VideoPage);
